import { render } from "./CadastroTelasInstitucionalView.vue?vue&type=template&id=20d85cae"
import script from "./CadastroTelasInstitucionalView.vue?vue&type=script&lang=js"
export * from "./CadastroTelasInstitucionalView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Garantidoras\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__